import { v4 as uuidv4 } from 'uuid';
import { Command } from 'ckeditor5/src/core';
import { FileRepository } from 'ckeditor5/src/upload';
import { toArray } from 'ckeditor5/src/utils';
export default class FileUploadCommand extends Command {
    execute(file) {
        const files = toArray(file);
        const selection = this.editor.model.document.selection;
        const selectionAttributes = Object.fromEntries(selection.getAttributes());
        files.forEach((file, index) => {
            const selectedElement = selection.getSelectedElement();
            // Inserting of an inline image replace the selected element and make a selection on the inserted image.
            // Therefore inserting multiple inline images requires creating position after each element.
            if (index && selectedElement) {
                const position = this.editor.model.createPositionAfter(selectedElement);
                this._uploadFile(file, selectionAttributes, position);
            }
            else {
                this._uploadFile(file, selectionAttributes);
            }
        });
    }
    refresh() {
        this.isEnabled = true;
    }
    _uploadFile(file, attributes, position) {
        // Set the file element id on the actual File so it is accessible in the upload adapter
        const fileReferenceId = uuidv4();
        file.fileReferenceId = fileReferenceId;
        const editor = this.editor;
        const fileRepository = editor.plugins.get(FileRepository);
        const loader = fileRepository.createLoader(file);
        // Do not throw when upload adapter is not set. FileRepository will log an error anyway.
        if (!loader) {
            return;
        }
        this._insertFile({ ...attributes, uploadId: loader.id }, file.name, fileReferenceId, position);
    }
    _insertFile(_attributes, fileName, fileReferenceId, position) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        // Mix declarative attributes with selection attributes because the new image should "inherit"
        // the latter for best UX. For instance, inline images inserted into existing links
        // should not split them. To do that, they need to have "linkHref" inherited from the selection.
        const attributes = {
            ...Object.fromEntries(selection.getAttributes()),
            ..._attributes,
            fileIsOpen: 'false',
            fileName,
            fileReferenceId
        };
        return model.change(writer => {
            const file = writer.createElement('file', { ...attributes });
            model.insertContent(file, position);
        });
    }
}
